import { AllCreatorsPage } from './AllCreatorsPage';

export const allCreatorsRouter = {
  '/@/creator/explore': AllCreatorsPage, // TODO: path 를 적어주세요.
};
